<template>
	<v-expansion-panels
		:class="{
			'majorityFilter': true,
		}"
		v-model="filterExpanded">
		<v-expansion-panel>
			<v-container
				fluid
        class="py-0">
        <v-row
          no-gutters
          style="min-height: 76px;"
          :class="{
            'fill-height': true,
          }">
          <v-col
            cols="12"
            xl="9"
            lg="9"
            md="9"
            sm="12"
            xs="12"
            :class="{
              'd-flex align-center': true,
              'pt-4': $vuetify.breakpoint.smAndDown
            }">
            <v-row
              :class="{
                'd-flex flex-column justify-center align-center': $vuetify.breakpoint.xs
              }">
              <v-col
                sm="6"
                :style="$vuetify.breakpoint.smAndDown ? '' : colFilter.styleMaxWidth"
                :class="{
                  'd-flex align-end': $vuetify.breakpoint.lgAndDown,
                  'd-flex flex-column align-center justify-center': $vuetify.breakpoint.smAndDown
                }">
                <v-menu
                  ref="competenceMenu"
                  v-model="competenceMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto">
                  <template
                    v-slot:activator="{ on }">
                    <Textfield
                      v-model="majorityFilterCompetence"
                      label="Competência *"
                      readonly
                      regular
                      hide-details
                      style="width: 100%"
                      v-on="on"
                    />
                  </template>

                  <v-date-picker
                    @click="setCompentence"
                    v-model="competenceDate"
                    type="month"
                    locale="pt-br"
                    color="primary"
                    no-title
                    scrollable>
                    <v-spacer />

                    <v-btn
                      text
                      color="primary"
                      @click="setCompentence">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col
                sm="6"
                :style="$vuetify.breakpoint.mdAndUp ? 'max-width: 424px;' : ''"
                class="d-flex align-end">
                <AdvancedSearch
                  @result="majorityFilterSearch = $event"
                  @resetAdvancedSearch="resetMajorityAdvancedSearch"
                  :resetAdvancedSearch="resetAdvancedSearch"
                  :items="advancedSearchFilters"
                  :isMultiple="false"
                  placeholder="Busca por nome ou cpf..."
                  isRegular
                  color="primary"
                />
              </v-col>
            </v-row>
          </v-col>

          <v-col
            :class="{
              'd-flex flex-row align-center': true,
              'justify-end': $vuetify.breakpoint.mdAndUp,
              'justify-space-between mt-4': $vuetify.breakpoint.smAndDown,
            }"
            cols="12"
            xl="3"
            lg="3"
            md="3"
            sm="12"
            xs="12">
            <div
              class="ml-2"
              :style="$vuetify.breakpoint.lgAndUp ? 'width: 270px' : 'width: 100%;'">
              <v-row
                :style="$vuetify.breakpoint.lgAndUp ? 'width: 290px;' : 'width: 100%;'">
                <v-col
                  :class="{
                    'd-flex align-center': true,
                    'justify-end pr-0': $vuetify.breakpoint.mdAndUp,
                    'justify-center pr-0': $vuetify.breakpoint.smAndDown,
                  }"
                  cols="2">
                  <v-badge
                    :content="counter"
                    color="error"
                    overlap
                    right="20"
                    v-if="counter > 0"
                    class="badgeCounter">
                    <v-icon
                      small
                      color="primary">
                      fas fa-filter
                    </v-icon>
                  </v-badge>
                </v-col>
                <v-col
                  :class="{
                    'd-flex align-center justify-center px-0': $vuetify.breakpoint.smAndDown
                  }"
                  cols="10">
                  <span
                    class="primary--text">
                    Expandir Opções de Pesquisa
                  </span>
                </v-col>
              </v-row>
            </div>

            <v-icon
              class="expansionIconClass"
              :style="expansionIconTransition"
              @click="expand"
              color="primary"
              size="30">
              mdi-chevron-up
            </v-icon>
          </v-col>
        </v-row>
			</v-container>

			<v-expansion-panel-content>
				<v-container
					fluid>
					<v-row
            no-gutters
            class="fill-height">
            <v-col
              cols="12"
              xl="11"
              lg="11"
              md="12"
              sm="12"
              xs="12"
              class="d-flex align-center">
              <v-row
                :class="{
                  'd-flex justify-center': $vuetify.breakpoint.mdAndDown,
                }">
                <v-col
                  cols="12"
                  md="6"
                  sm="6"
                  :style="
                    $vuetify.breakpoint.lgAndUp ? colFilter.style : ''
                  ">
                  <Autocomplete
                    label="Grupo Financeiro"
                    @change="setFinancialGroup"
                    :value="majorityFilter.financialGroupId"
                    :items="financialGroups"
                    :readonly="financialGroups && financialGroups.length === 1"
                    :clearable="financialGroups && financialGroups.length > 1"
                    item-text="name"
                    item-value="id"
                    placeholder="Selecione"
                    regular
                    hide-details
                    color="primary"
                    item-color="primary"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  sm="6"
                  :style="
                    $vuetify.breakpoint.lgAndUp ? colFilter.style : ''
                  ">
                  <Autocomplete
                    label="Contrato"
                    @change="setContract(
                      $event
                        ? $event.id
                        : null,
                      $event)"
                    :value="majorityFilter.contractId"
                    :items="contracts"
                    :loading="loadingContracts"
                    item-text="text"
                    item-value="id"
                    placeholder="Selecione"
                    clearable
                    regular
                    hide-details
                    return-object
                    color="primary"
                    item-color="primary"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  sm="6"
                  :style="
                    $vuetify.breakpoint.lgAndUp ? colFilter.style : ''
                  ">
                  <Autocomplete
                    label="Subcontrato"
                    @change="setSubContract"
                    :value="majorityFilter.subContractId"
                    :items="subContracts"
                    :loading="loadingSubContracts"
                    item-text="text"
                    item-value="id"
                    clearable
                    regular
                    color="primary"
                    item-color="primary"
                    hide-details
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  sm="6"
                  v-if="showProtocolFilter"
                  :style="
                    $vuetify.breakpoint.lgAndUp ? colFilter.style : ''
                  ">
                  <Autocomplete
                    label="Protocolo"
                    @change="setExternalProtocol"
                    :value="majorityFilter.externalProtocol"
                    :items="majorityProtocols"
                    placeholder="Selecione"
                    clearable
                    regular
                    hide-details
                    color="primary"
                    item-color="primary"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  sm="6"
                  :style="
                    $vuetify.breakpoint.lgAndUp ? colFilter.style : ''
                  ">
                  <Autocomplete
                    label="Operadora"
                    @change="setInsuranceCarrier"
                    :value="majorityFilter.carrierId"
                    :items="insuranceCarriers"
                    item-text="xipp_commercial_name"
                    item-value="id"
                    clearable
                    regular
                    hide-details
                    color="primary"
                    item-color="primary"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  sm="6"
                  :style="
                    $vuetify.breakpoint.lgAndUp ? colFilter.style : ''
                  ">
                  <Autocomplete
                    label="Meses de Antecedência"
                    @change="setMajorityFilter({monthsAdvance: $event})"
                    :value="majorityFilter.monthsAdvance"
                    :items="monthsAdvances"
                    item-text="value"
                    item-value="id"
                    multiple
                    clearable
                    regular
                    color="primary"
                    item-color="primary"
                    hide-details>
                    <template
                      v-slot:selection="{ item, index }">
                      <v-chip
                        v-if="index < 1"
                        small>
                        <span>{{ item.value }}</span>
                      </v-chip>

                      <span
                        v-if="index === 1"
                        class="foreground--text text-caption">
                        {{
                          formatter.getPluralText(
                            "outro",
                            majorityFilter.monthsAdvance
                          )
                        }}
                      </span>
                    </template>
                  </Autocomplete>
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  sm="6"
                  :style="
                    $vuetify.breakpoint.lgAndUp ? colFilter.style : ''
                  ">
                  <Autocomplete
                    label="Permanência"
                    :value="majorityFilter.coverageExtensionReason"
                    @change="setMajorityFilter({coverageExtensionReason: $event})"
                    :items="coverages"
                    item-text="description"
                    item-value="id"
                    clearable
                    regular
                    hide-details
                    color="primary"
                    item-color="primary"
                  />
                </v-col>

                <v-col
                  :cols="$vuetify.breakpoint.smAndDown ? '12': '6'"
                  :class="{
                    'd-flex gap-h-20': true,
                    'justify-center align-center': $vuetify.breakpoint.mdAndDown,
                    'flex-column gap-v-20': $vuetify.breakpoint.smAndDown
                  }">
                  <v-btn
                    color="primary"
                    :style="btnFilter.style"
                    @click="searchMajorities">
                    Pesquisar
                  </v-btn>

                  <v-btn
                    class="primary--text"
                    color="muted"
                    :style="btnFilter.style"
                    @click="reset">
                    Limpar Filtros
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
					</v-row>
				</v-container>
			</v-expansion-panel-content>
		</v-expansion-panel>
	</v-expansion-panels>
</template>

<script>
import AdvancedSearch from '../../../AdvancedSearch/AdvancedSearch.vue';
import Formatters from '@/shared/formatters/formatters';
import Autocomplete from '../MajorityAutocomplete.vue';
import Textfield from '../MajorityTextfield.vue';
import moment from 'moment';
moment.locale('pt-br');

import MajorityMixin from '@/shared/mixins/majority/majorityMixin';
import ContractsMixin from '@/shared/mixins/sdi/contractsMixin';
import MajorityRules from '../../rules/majorityRules.js';
import { mapActions, mapGetters } from 'vuex';

export default {
	name: "MajorityFilter",

  components: {
    AdvancedSearch,
    Autocomplete,
    Textfield,
  },

	data: () => ({
    moment,
    formatter: null,

    loadingContracts: false,
    loadingSubContracts: false,
    contracts: [],
    subContracts: [],

    filterExpanded: null,

    competenceDate: null,
    competenceMenu: false,

    resetAdvancedSearch: false,

    advancedSearchFilters: [
      { id: 'name', label: 'Nome' },
      { id: 'document', label: 'CPF' },
    ],
	}),

  mixins: [
    ContractsMixin,
    MajorityMixin,
    MajorityRules,
  ],

  watch: {
    financialGroups(groups) {
      if (groups && groups.length === 1) {
        this.setFinancialGroup(groups[0].id);
      }
    },

    'majorityFilter.financialGroupId': {
      async handler(financialGroupId) {
        if (financialGroupId && this.hasMajorityQueryParameters()) {
          if (this.majorityFilter.financialGroupId) {
            await this.getContractsByFinancialGroupIdVerifyRhProtegido(this.majorityFilter.financialGroupId, this.isRHProtegido);
          }
        }
      },
    },

    'majorityFilter.contractId': {
      async handler(contractId) {
        if (contractId && this.hasMajorityQueryParameters()) {
          if (this.majorityFilter.contractId) {
            await this.getSubContractsByContractId(this.majorityFilter.contractId);

            const contractSelect = this.contracts.find((contract) => contract.id === this.majorityFilter.contractId);

            if (contractSelect)
              this.fetchInsuranceCarrierByContract(contractSelect);
          }
        }
      },
    },
  },

	methods: {
    ...mapActions({
      setMajorityFilter: 'majority/setMajorityFilter',
      fetchParameters: 'majority/fetchParameters',
      searchMajorities: 'majority/search',
      resetFilter: 'majority/resetFilter',
    }),

    reset() {
      this.resetAdvancedSearch = true;
      if (!this.isRHProtegido) this.contracts = [];
      this.subContracts = [];
      this.resetFilter(this.isRHProtegido);
    },

    resetMajorityAdvancedSearch() {
      setTimeout(() => {
        this.resetAdvancedSearch = false;
      }, 500);
    },

    async setFinancialGroup(financialGroupId) {
      this.setMajorityFilter({financialGroupId: financialGroupId});

      if (!financialGroupId) {
        this.setContract(null);
        this.setSubContract(null);
        this.setExternalProtocol(null);

        this.contracts = [];
        this.subContracts = [];

        return;
      }

      await this.getContractsByFinancialGroupIdVerifyRhProtegido(financialGroupId, this.isRHProtegido);
    },

    async setContract(contractId, contract) {
      this.setMajorityFilter({contractId: contractId});

      if (!contractId) {
        this.setSubContract(null);
        this.setExternalProtocol(null);
        this.subContracts = [];

        return;
      }

      if (contract) {
        this.fetchInsuranceCarrierByContract(contract);
      }

      if (!this.isRHProtegido) {
        await this.fetchParameters();

        const mostRecentExternalProtocol = this.getMostRecentProtocol();

        if (mostRecentExternalProtocol) {
          this.setExternalProtocol(mostRecentExternalProtocol);
        }

        await this.searchMajorities();
      }

      await this.getSubContractsByContractId(contractId);
    },

    fetchInsuranceCarrierByContract(contract) {
      const contractWithFields = this.formatter.getFilledKeysFromObject(contract);
        const { carrier_id } = contractWithFields;

        if (carrier_id) {
          this.setInsuranceCarrier(carrier_id.id);
        }
    },

    getMostRecentProtocol() {
      return this.majorityProtocols.length > 0 ? Math.max(...this.majorityProtocols) : false;
    },

    setSubContract(subContractId) {
      this.setMajorityFilter({subContractId: subContractId});
    },

    setInsuranceCarrier(carrierId) {
      this.setMajorityFilter({carrierId: carrierId});
    },

    setExternalProtocol(externalProtocol) {
      this.setMajorityFilter({externalProtocol: externalProtocol});
    },

    setCompentence() {
			if (Boolean(this.competenceDate)) {
        const competenceMonth = parseInt(moment(this.competenceDate, 'YYYY-MM').format('MM'));
        const competenceYear = parseInt(moment(this.competenceDate, 'YYYY-MM').format('YYYY'));

        this.setMajorityFilter({
          competenceMonth: competenceMonth,
          competenceYear: competenceYear,
        });
			}

      this.competenceMenu = false;
    },

		expand() {
			if (this.filterExpanded === 0) {
				this.filterExpanded = undefined;

        return;
			}

      this.filterExpanded = 0;
		},
	},

	computed: {
    ...mapGetters({
      majorityProtocols: 'majority/majorityProtocols',
      counter: 'majority/majorityFilterCounter',
      monthsAdvances: 'majority/monthsAdvances',
      filter: 'majority/majorityFilter',
      majorities: 'majority/majorities',
      coverages: 'majority/coverages',

      insuranceCarriers: 'insurance-carrier/insuranceCarriers',
      financialGroups: 'financial-group/groups',

      isRHProtegido: 'user-info/isRHProtegido',
    }),

    majoritiesView() {
      return this.majoritiesViewValidation(this.majorities);
    },

    majorityFilter() {
      return this.filter;
    },

    majorityFilterSearch: {
      get() {
        return this.filter.document | this.filter.name;
      },

      set(searchs) {
        const name = searchs.find((el) => el.key === 'name')?.value[0] ?? null;
        const cpf = searchs.find((el) => el.key === 'document')?.value[0] ?? null;
        const cpfFormatted = cpf ? cpf.replace(/\.|-/g, '') : null;

        this.setMajorityFilter({
          name: name,
          cpf: cpfFormatted,
        });
      },
    },

    majorityFilterCompetence: {
      get() {
        if (!this.filter.competenceMonth || !this.filter.competenceYear) return null;

        const monthName = moment().month(this.filter.competenceMonth - 1).format('MMMM');
        const monthCapitalized = monthName.charAt(0).toUpperCase() + monthName.slice(1);

        return `${monthCapitalized} ${this.filter.competenceYear}`;
      },

      set(value) {
      }
    },

		expansionIconTransition() {
			return {
        transform: this.filterExpanded !== 0 ? 'rotate(180deg)' : 'rotate(0deg)',
        transition: 'transform 0.25s',
      };
		},
	},

  created() {
    this.formatter = new Formatters();
  },
}
</script>

<style scoped lang="scss">
.expansionIconClass {
	background-color: transparent !important;
}
.expansionIconClass:after {
	background-color: transparent !important;
}

@keyframes rotate {
  from {
    transform: rotate(360deg);
  }
  to {
    transform: rotate(0deg);
  }
}

.syncSearchTransition {
	transform: 0.5s ease-out;
  animation: rotate 1.2s linear infinite;
}

.majorityFilter {
  border-radius: 5px !important;
  box-shadow: 0px 3px 6px color-mix(in srgb, var(--v-shadow-base) 26%, transparent);

  > .v-expansion-panel::before {
    box-shadow: none !important;
  }

  > .v-expansion-panel {
    > .v-expansion-panel-content {
      > div {
        padding: 0px !important;
      }
    }
  }

  .v-expansion-panel-content__wrap {
    padding: 0px !important;
  }
}
</style>

<style lang="scss">
.majorityFilter {
  .v-expansion-panel-content__wrap {
    padding: 0px !important;
  }
}
</style>
